import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ArticleSuggestions from '../article-suggestions/article-suggestions';
import ArticleBuilder from '../../../services/article-builder/article-builder';
import { localStorage, LocalStorageKeysMapping } from '../../../services/local-storage/local-storage';
import LoadingIndication from '../../common/loading-indicator';
import TagsBar from '../../common/tags-bar';
import Level from '../../common/level';
import ArticlesNavigationBar from './articles-navigation-bar';
import CustomReadingProgress from '../../common/custom-reading-progress';
import AnimatedWrapper from '../../core/animated-wrapper';
import shareService from '../../../services/share';
import articlesService from '../../../services/articles';
import articleTagsService from '../../../services/article-tags/article-tags';
import TwitterFollowButton from '../../common/twitter-follow-button';
import SmartAd from '../../ads/smart-ad';

import './article.css';
import AdUIService from '../../../services/ads/ui';

class Article extends Component {
  LocalStorageSeenKey = 'SEEN_MY_ARTICLES';

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false
    };

    this._pullArticleByProps(props);  
  }

  componentDidUpdate() {
    window.twttr.widgets.load();
  }

  // componentDidUpdate(props) {
  // }

  _pullArticleByProps(props) {
    this.setState({
      isLoading: true,
      isError: false 
    });
    
    const articleId = this._getArticleIdByProps(props);
    
    if (articleId === -1) {
      this.setState({
        isLoading: false,
        isError: true 
      });

      return;
    }

    articlesService.getFullArticleById(articleId)
      .then(article => {
        const builder = new ArticleBuilder(article);
        const contentJSX = builder.generateJSX();
        const relevantTagsData = articleTagsService.getRelevantMyArticleTags(article.tags);

        const newState = Object.assign({
            isLoading: false,
            ...article,
            _id: articleId,
            contentJSX: AdUIService.putEvery(contentJSX, SmartAd, 3, 20, { tags: article.tags }),
          }, {
            tags: relevantTagsData,
            tagsStr: relevantTagsData.map(tagData => tagData.id),
          });

        this.setState(newState);

        this._signAsSeenInLocalStorage(articleId);

        shareService.setupPage({ 
          title: `"${article.title.slice(0, 80)}${article.title.length > 80 ? '...' : ''}"`,
          fullTitle: article.title,
          isTitlePrefixOn: false,
          tags: article.tags 
        });    
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });    
  }

  _getArticleIdByProps(props) {
    const lastIndexOfDash = props.match.params.linkId.lastIndexOf('-');
    if (lastIndexOfDash === -1) {
      return -1;
    }
    
    return Number(props.match.params.linkId.slice(lastIndexOfDash + 1));    
  }

  _signAsSeenInLocalStorage(articleId) {
    const key = `${LocalStorageKeysMapping[this.LocalStorageSeenKey]}_${articleId}`;
    localStorage.setItem(key, 'true');
  }
  
  render() {
    if (this.state.isLoading) {
      return (
        <section className='regular-page full-article'>
          <LoadingIndication />
        </section>
      );
    }

    if (this.state.isError) {
      return (
        <section className='regular-page full-article'>
          <div>Article not found</div>
        </section>
      );
    }

    const imgSrc = `/images/articles/${this.state._id}/main.png`;

    // const meta = {
    //   title: this.state.title,
    //   description: 'I am a description, and I can create multiple tags',
    //   canonical: 'http://example.com/path/to/page',
    //   meta: {
    //     charset: 'utf-8',
    //     name: {
    //       keywords: this.state.tags.join(',')
    //     }
    //   }
    // };

    return (
      <section className='regular-page full-article'>
        { this.props.isAnimationEnded ? <CustomReadingProgress targetEl='.article-content' /> : ''}
        
        <section className='article-container'>
          <div className='articles-navigation-bar-container'>            
            <ArticlesNavigationBar articleId={this.state._id} prevLinkId={this.state.prevLinkId} nextLinkId={this.state.nextLinkId} />
          </div> 

          <div className='date-and-tags-container'>
            {/* <div className='date'>{this.state.date}</div> */}
            <TagsBar tags={this.state.tags} />
          </div>

          <div className='level-container'>
            <Level level={this.state.level} />
          </div>             
          
          <h3 className='page-title'>{this.state.title}</h3>
          <hr className='title-separator' />
          <h4 className='sub-title'>{this.state.subTitle}</h4>
          
          <div className='article-image-and-content'>
            <div className='article-image-container'>
              <img 
                src={imgSrc} 
                alt={this.state.title}
                title={this.state.title}
                height='280px' />
            </div>

            <div className='article-content'>
              {this.state.contentJSX}
              <SmartAd key='ad-banner-last' tags={this.state.tags} forceShowAd />
            </div>
          </div>
        </section>

        <div className="follow-me-in-twitter-container">
          <TwitterFollowButton />
        </div>

        <hr className='sections-separator' />

        <section className='article-suggestions'>
          <ArticleSuggestions articleId={this.state._id} articleTags={this.state.tagsStr} />
        </section>
      </section>
    );
  }
}

Article.propTypes = {
  isAnimationEnded: PropTypes.bool.isRequired
};

const AnimatedArticle = AnimatedWrapper(Article);
export default AnimatedArticle;